import { PlatformConstants } from "@quest/platform-murka-phase_2/dist/PlatformConstants"


export class PlatformConstantsGame extends PlatformConstants {
    // code here
}
PlatformConstants.BASE_GAME_REELSET = 'base_reel';
PlatformConstants.FREE_GAME_REELSET = 'free_reel';


